import { Component, OnInit, ViewChild } from '@angular/core';
import { MessagesService } from './messages.service';
import { Messages, MessageType, ResultModel } from './messages.models';
import { MessagesDataSource } from './messages.datasource';
import { MatPaginator } from '@angular/material/paginator';
import { PageEvent } from '@angular/material/paginator';
import { DEFAULT_PAGE_SIZE } from 'src/app/admin/admin-home/admin-fee-definition/fee-definition-model';
import { MatDialog } from '@angular/material/dialog';
import { MessagePortalContentComponent } from 'src/portal/components/messeges-content/message-portal-content.component';
import { ItemPickerModel } from 'src/app/shared/components/item-picker/models/itemPickerModel';

@Component({
  selector: 'app-messages',
  templateUrl: './messages.component.html',
  styleUrls: ['./messages.component.scss'],
  standalone: false
})
export class MessagesComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  messages: ResultModel[] = [];
  loading = true;
  readonly dataSource: MessagesDataSource;
  pageSize: number = DEFAULT_PAGE_SIZE;
  filterItems: ItemPickerModel[] = [new ItemPickerModel(null, null, 'All Types')];
  selectedFilterValue: ItemPickerModel = this.filterItems[0];

  constructor(
    messagesService: MessagesService,
    private dialog: MatDialog
  ) {
    this.dataSource = new MessagesDataSource(messagesService);
  }

  async ngOnInit(): Promise<void> {
    await this.dataSource.loadMessages(this.paginator.pageIndex, this.pageSize);
    const messageTypes = Object.values(MessageType);
    messageTypes.forEach((type) => {
      this.filterItems.push(new ItemPickerModel(type, null, type));
    });
    this.loading = false;
  }

  onPageChange(event: PageEvent) {
    this.dataSource.loadMessages(event.pageIndex, this.pageSize);
  }

  viewMessage(message: Messages, event: Event): void {
    const triggerElement = event.currentTarget as HTMLElement;
    const dialogRef = this.dialog.open(MessagePortalContentComponent, {
      data: {
        id: message.id,
        subject: message.subject,
        senderName: message.senderName,
        sender: message.sender,
        sentOn: message.sentOn
      },
      width: '95%',
      maxWidth: '1600px',
      height: '95%',
      maxHeight: '1200px'
    });
    dialogRef.afterClosed().subscribe(() => triggerElement.focus());
  }

  itemPickerSelected(item: ItemPickerModel) {
    this.selectedFilterValue = item;
    this.paginator.pageIndex = 0;
    this.dataSource.filterByMessageType(this.paginator.pageIndex, this.pageSize, item.id);
  }
}
